import { all, spawn } from "redux-saga/effects";
import pageSagas from "sagas/PageSagas";
import errorSagas from "./ErrorSagas";
import applicationSagas from "./ApplicationSagas";
import { watchDatasourcesSagas } from "./DatasourcesSagas";
import initSagas from "./InitSagas";
import userSagas from "./userSagas";
import orgSagas from "./OrgSagas";
import themeSagas from "./ThemeSaga";

export function* rootSaga() {
  yield all([
    spawn(initSagas),
    spawn(pageSagas),
    spawn(errorSagas),
    spawn(watchDatasourcesSagas),
    spawn(applicationSagas),
    spawn(userSagas),
    spawn(orgSagas),
    spawn(themeSagas),
  ]);
}
